module.exports = __webpack_public_path__ + "img/m4_t1_bg.1a14c2ce.svg";